export const estateDashboardMessages = Object.freeze({
  // meta
  'estate_dashboard.meta.title': 'Prodej nemovitosti bez starostí',

  // amenity warning
  'estate_dashboard.amenity_warning':
    'Odhad může být zkreslený vzhledem k zadaným hodnotám: {firstAmenityText}{otherAmenitiesText}.',
  'estate_dashboard.amenity_warning.garden_area': 'Zahrada ({amount} m²)',
  'estate_dashboard.amenity_warning.balcony_area': 'Balkon ({amount} m²)',
  'estate_dashboard.amenity_warning.loggia_area': 'Lodžie ({amount} m²)',
  'estate_dashboard.amenity_warning.terrace_area': 'Terasa ({amount} m²)',
  'estate_dashboard.amenity_warning.cellar_area': 'Sklep ({amount} m²)',
  'estate_dashboard.amenity_warning.garage_count': 'Garáž ({amount} stání)',
  'estate_dashboard.amenity_warning.parking_space_count':
    'Parkovací stání ({amount} stání)',
  'estate_dashboard.amenity_warning.covered_parking_space_count':
    'Kryté parkovací stání ({amount} stání)',
  'estate_dashboard.amenity_warning.uncovered_parking_space_count':
    'Nekryté parkovací stání ({amount} stání)',
  'estate_dashboard.amenity_warning.conjunction': ' a ',
  'estate_dashboard.amenity_warning.other_amenities': `{count, plural,
    one {další}
    few {další}
    other {dalších}
  } {count}`,

  // panorama section
  'estate_dashboard.panorama.bullet': '• ',
  'estate_dashboard.panorama.floor_area': ' •&nbsp{area}&nbsp;m²',
  'estate_dashboard.panorama.unit_number':
    ' •&nbspJednotka č.:&nbsp{unitNumber}',

  // estimate section
  'estate_dashboard.estimate.title_tooltip.flat':
    'Odhad ceny jsme vypočítali na základě dat o podobných bytech prodaných v okolí a zohlednili přitom zadané parametry bytu (viz níže).<br></br>Ceny prodaných bytů vychází z aktuálních dat Katastru nemovitostí.',
  'estate_dashboard.estimate.title_tooltip.house':
    'Odhad ceny jsme vypočítali na základě dat o podobných domech prodaných v okolí a zohlednili přitom zadané parametry domu (viz níže).<br></br>Ceny prodaných domů vychází z aktuálních dat Katastru nemovitostí.',
  'estate_dashboard.estimate.title': 'Odhadovaná cena',
  'estate_dashboard.estimate.error':
    'Při počítání odhadu došlo k chybě, zkuste prosím obnovit stránku nebo to zkuste později.',
  'estate_dashboard.estimate.price_range_millions':
    '{low}&nbsp;mil. - {high}&nbsp;mil.',
  'estate_dashboard.estimate.price_millions': '{mid}&nbsp;mil.',
  'estate_dashboard.estimate.price': '{estimate}&nbsp;Kč',
  'estate_dashboard.estimate.price_feedback':
    'Očekávali jste jinou cenu? {feedbackLink}',
  'estate_dashboard.estimate.price_feedback_link':
    ' Pošlete nám zpětnou vazbu.',
  'estate_dashboard.estimate.subscribe.button': 'Sledovat cenu',
  'estate_dashboard.estimate.no_estimate.title':
    'Omlouváme se, cenu této nemovitosti zatím nedokážeme spolehlivě odhadnout na dálku.',

  'estate_dashboard.estimate.confidence.tooltip':
    '<b>Míra jistoty odpovídá množství dat, jimiž disponujeme o podobných nemovitostech prodaných v okolí.</b><br/><br/>Nízká jistota může být způsobena tím, že není dost dat o nedávných prodejích a nebo je vaše nemovitost jedinečná. Pokud je jistota vysoká, máme nejspíše více dostupných dat o podobných prodaných nemovitostech v okolí.',
  'estate_dashboard.estimate.confidence.high': 'Velmi vysoká jistota',
  'estate_dashboard.estimate.confidence.medium': 'Vysoká jistota',
  'estate_dashboard.estimate.confidence.low': 'Střední jistota',
  'estate_dashboard.estimate.confidence.terrible': 'Nízká jistota',

  // A/B test - estimate feedback
  'estate_dashboard.estimate.b.feedback.title':
    'Odpovídá odhadovaná cena vašemu očekávání?',
  'estate_dashboard.estimate.b.feedback.lower_price': 'Odhad je nižší',
  'estate_dashboard.estimate.b.feedback.corresponding_price': 'Odhad odpovídá',
  'estate_dashboard.estimate.b.feedback.higher_price': 'Odhad je vyšší',

  // get offer section - flat
  'estate_dashboard.get_offer.title': 'Chcete prodat váš byt?',
  'estate_dashboard.get_offer.copy':
    'Podobný byt s námi aktuálně <b>hledá {buyerCount} zájemců</b>',
  'estate_dashboard.get_offer.cta': 'Zjistit zájem',

  // get offer section - house
  'estate_dashboard.get_offer.house.title': 'Chcete prodat váš dům?',
  'estate_dashboard.get_offer.house.copy':
    'Podobný dům s námi aktuálně <b>hledá {buyerCount} zájemců</b>',

  // get offer section - house subscribe
  'estate_dashboard.house.subscribe.title': 'Nový odhad ceny domu již brzy!',
  'estate_dashboard.house.subscribe.copy':
    'Usilovně pracujeme na tom, abychom spočítali odhad ceny online i pro tento dům. Spuštění plánujeme na prosinec 2021.',
  'estate_dashboard.house.subscribe.cta': 'Chci být informován',

  // Offer survey link section
  'estate_dashboard.get_offer_link.title': 'Přemýšlíte o prodeji?',
  'estate_dashboard.get_offer_link.subtitle':
    'Vyplňte nám, prosím, několik nezbytných informací o vaší nemovitosti a naši realitní specialisté se s vámi obratem spojí.',
  'estate_dashboard.get_offer_link.button': 'Získat nabídku',

  // show in Atlas section
  'estate_dashboard.atlas.title': 'Zajímá vás více informací?',
  'estate_dashboard.atlas.subtitle':
    'Zjistěte, jak se cena této nemovitosti vyvíjí v čase nebo za kolik se prodávají nemovitosti v okolí.',
  'estate_dashboard.atlas.button': 'Zobrazit v Atlasu cen',

  // no info section
  'estate_dashboard.estate_info.table.no_estimate':
    'Bohužel, cenu této nemovitosti zatím nedokážeme spolehlivě odhadnout.',

  // info section - table
  'estate_dashboard.estate_info.table.title': 'Podrobnosti o nemovitosti',
  'estate_dashboard.estate_info.table.atlas_link':
    'Upravit údaje (otevře Atlas cen)',
  'estate_dashboard.estate_info.table.estate_type': 'Typ nemovitosti',
  'estate_dashboard.estate_info.table.building_type': 'Typ nemovitosti',
  'estate_dashboard.estate_info.table.area': 'Podlahová plocha',
  'estate_dashboard.estate_info.table.floor_area': 'Podlahová plocha',
  'estate_dashboard.estate_info.table.land_area': 'Plocha pozemku',
  'estate_dashboard.estate_info.table.disposition': 'Dispozice',
  'estate_dashboard.estate_info.table.unit_number': 'Číslo jednotky',
  'estate_dashboard.estate_info.table.ownership': 'Vlastnictví',
  'estate_dashboard.estate_info.table.construction_type': 'Typ konstrukce',
  'estate_dashboard.estate_info.table.floors': 'Počet podlaží',
  'estate_dashboard.estate_info.table.floor_number': 'Podlaží bytu',
  'estate_dashboard.estate_info.table.elevator': 'Výtah',
  'estate_dashboard.estate_info.table.finished_at': 'Rok výstavby',
  'estate_dashboard.estate_info.table.finished_at_interval': 'Rok výstavby',
  'estate_dashboard.estate_info.table.building_condition': 'Stav&nbsp;budovy',
  'estate_dashboard.estate_info.table.kitchen_condition': 'Stav&nbsp;kuchyně',
  'estate_dashboard.estate_info.table.bathroom_condition': 'Stav&nbsp;koupelny',
  'estate_dashboard.estate_info.table.house_separation': 'Poloha domu',
  'estate_dashboard.estate_info.table.nearby_traffic_routes':
    'Rušná dopravní tepna',

  'estate_dashboard.estate_info.table.area_value': '{area}&nbsp;m²',

  // info section - toggle
  'estate_dashboard.estate_info.toggle.open': 'Rozbalit',
  'estate_dashboard.estate_info.toggle.close': 'Skrýt',

  // estate type
  'estate_dashboard.estate_info.table.estate_type.unit': 'Byt',
  'estate_dashboard.estate_info.table.estate_type.building': 'Dům',
  'estate_dashboard.estate_info.table.estate_type.commercial_object':
    'Komerční objekt',
  'estate_dashboard.estate_info.table.estate_type.other': 'Jiné',
  'estate_dashboard.estate_info.table.estate_type.land': 'Pozemek',

  // building type
  'estate_dashboard.estate_info.table.building_type.family_house':
    'Rodinný dům',
  'estate_dashboard.estate_info.table.building_type.recreational_building':
    'Rekreační',
  'estate_dashboard.estate_info.table.building_type.other': 'Jiné',

  // dispositions
  'estate_dashboard.estate_info.table.disposition.1+kk': '1+kk',
  'estate_dashboard.estate_info.table.disposition.1+1': '1+1',
  'estate_dashboard.estate_info.table.disposition.2+kk': '2+kk',
  'estate_dashboard.estate_info.table.disposition.2+1': '2+1',
  'estate_dashboard.estate_info.table.disposition.3+kk': '3+kk',
  'estate_dashboard.estate_info.table.disposition.3+1': '3+1',
  'estate_dashboard.estate_info.table.disposition.4+kk': '4+kk',
  'estate_dashboard.estate_info.table.disposition.4+1': '4+1',
  'estate_dashboard.estate_info.table.disposition.4+1_and_larger':
    '4+1 a větší',
  'estate_dashboard.estate_info.table.disposition.larger': '5+kk a větší',

  // ownership
  'estate_dashboard.estate_info.table.ownership.private': 'Osobní',
  'estate_dashboard.estate_info.table.ownership.collective': 'Družstevní',
  'estate_dashboard.estate_info.table.ownership.national_or_municipal':
    'Státní/obecní',
  'estate_dashboard.estate_info.table.ownership.mixed': 'Smíšené',
  'estate_dashboard.estate_info.table.ownership.other': 'Jiné',

  // conditions
  'estate_dashboard.estate_info.table.conditions.excellent': 'Výborný',
  'estate_dashboard.estate_info.table.conditions.newish': 'Zánovní',
  'estate_dashboard.estate_info.table.conditions.good': 'Dobrý',
  'estate_dashboard.estate_info.table.conditions.bad': 'Špatný',

  // construction types
  'estate_dashboard.estate_info.table.construction_type.brick_cinder_block':
    'Cihla',
  'estate_dashboard.estate_info.table.construction_type.stone': 'Cihla',
  'estate_dashboard.estate_info.table.construction_type.brick_stone': 'Cihla',
  'estate_dashboard.estate_info.table.construction_type.brick': 'Cihla',
  'estate_dashboard.estate_info.table.construction_type.panel': 'Panel',
  'estate_dashboard.estate_info.table.construction_type.mudbrick': 'Cihla',
  'estate_dashboard.estate_info.table.construction_type.wood': 'Dřevo',
  'estate_dashboard.estate_info.table.construction_type.other': 'Jiný',
  'estate_dashboard.estate_info.table.construction_type.brick_stone_cinder_block':
    'Cihla',
  'estate_dashboard.estate_info.table.construction_type.monolith': 'Monolit',
  'estate_dashboard.estate_info.table.construction_type.unknown': 'Neznámý',

  'estate_dashboard.estate_info.table.house_separation.terraced':
    'Řadový / v bloku',
  'estate_dashboard.estate_info.table.house_separation.stand_alone':
    'Samostatný',

  'estate_dashboard.estate_info.table.nearby_traffic_routes.airport': 'Letiště',
  'estate_dashboard.estate_info.table.nearby_traffic_routes.railway':
    'Železnice',
  'estate_dashboard.estate_info.table.nearby_traffic_routes.main_road':
    'Silnice / Dálnice',

  'estate_dashboard.estate_info.table.elevator.has_elevator': 'Ano',
  'estate_dashboard.estate_info.table.elevator.no_elevator': 'Ne',
  'estate_dashboard.estate_info.table.elevator.unknown': 'Nezjištěno',

  // yes no
  'estate_dashboard.estate_info.table.yes': 'Ano',
  'estate_dashboard.estate_info.table.no': 'Ne',

  'estate_dashboard.estate_info.table.unknown': 'Neznámý',

  // info section - amenities
  'estate_dashboard.estate_info.amenities.title': 'Příslušenství',
  'estate_dashboard.estate_info.amenities.garden_area_value':
    'Zahrada ({value}&nbsp;m²)',
  'estate_dashboard.estate_info.amenities.balcony_area_value':
    'Balkon ({value}&nbsp;m²)',
  'estate_dashboard.estate_info.amenities.loggia_area_value':
    'Lodžie ({value}&nbsp;m²)',
  'estate_dashboard.estate_info.amenities.terrace_area_value':
    'Terasa ({value}&nbsp;m²)',
  'estate_dashboard.estate_info.amenities.cellar_area_value':
    'Sklep ({value}&nbsp;m²)',
  'estate_dashboard.estate_info.amenities.garage_count_value':
    'Garáž ({value} stání)',
  'estate_dashboard.estate_info.amenities.parking_space_count_value':
    'Parkování ({value}&nbsp;stání)',
  'estate_dashboard.estate_info.amenities.covered_parking_space_count_value':
    'Kryté parkování ({value}&nbsp;stání)',
  'estate_dashboard.estate_info.amenities.uncovered_parking_space_count_value':
    'Nekryté parkování ({value}&nbsp;stání)',
  'estate_dashboard.estate_info.amenities.pool_type_value': 'Bazén ({value})',
  'estate_dashboard.estate_info.amenities.pergola_type_value':
    'Pergola ({value})',
  'estate_dashboard.estate_info.amenities.solar_panels_purpose_and_area_value':
    'Solární panely ({value})',
  'estate_dashboard.estate_info.amenities.heat_pump_type_value':
    'Tepelné čerpadlo ({value})',
  'estate_dashboard.estate_info.amenities.fireplace_type_value':
    'Krb ({value})',
  'estate_dashboard.estate_info.amenities.sauna_type_value': 'Sauna ({value})',
  'estate_dashboard.estate_info.amenities.garden': 'Zahrada',
  'estate_dashboard.estate_info.amenities.balcony': 'Balkon',
  'estate_dashboard.estate_info.amenities.loggia': 'Lodžie',
  'estate_dashboard.estate_info.amenities.terrace': 'Terasa',
  'estate_dashboard.estate_info.amenities.cellar': 'Sklep',
  'estate_dashboard.estate_info.amenities.garage': 'Garáž',
  'estate_dashboard.estate_info.amenities.parking_space': 'Parkování',
  'estate_dashboard.estate_info.amenities.covered_parking_space':
    'Kryté parkování',
  'estate_dashboard.estate_info.amenities.uncovered_parking_space':
    'Nekryté parkování',

  'estate_dashboard.estate_info.amenities.pool_type.sunken': 'Zapuštěný',
  'estate_dashboard.estate_info.amenities.pool_type.semi_sunken':
    'Polozapuštěný',
  'estate_dashboard.estate_info.amenities.pool_type.above_ground': 'Nadzemní',
  'estate_dashboard.estate_info.amenities.pergola_type.classic': 'Klasická',
  'estate_dashboard.estate_info.amenities.pergola_type.glassed': 'Zasklená',
  'estate_dashboard.estate_info.amenities.pergola_type.bio_climatic':
    'Bioklimatická',

  'estate_dashboard.estate_info.amenities.solar_panel.electricity_generation':
    'Výroba elektřiny',
  'estate_dashboard.estate_info.amenities.solar_panel.water_heating':
    'Ohřev vody',
  'estate_dashboard.estate_info.amenities.solar_panel.electricity_generation_water_heating':
    'Ohřev + Elektřina',

  'estate_dashboard.estate_info.amenities.heat_pump_type.air_air':
    'Vzduch-vzduch',
  'estate_dashboard.estate_info.amenities.heat_pump_type.air_water':
    'Vzduch-voda',
  'estate_dashboard.estate_info.amenities.heat_pump_type.water_water':
    'Voda-voda',
  'estate_dashboard.estate_info.amenities.heat_pump_type.ground_water':
    'Země-voda',

  'estate_dashboard.estate_info.amenities.fireplace_type.burner_stove':
    'Krbová kamna',
  'estate_dashboard.estate_info.amenities.fireplace_type.built_in':
    'Zabudovaný krb',
  'estate_dashboard.estate_info.amenities.fireplace_type.tiled':
    'Kachlová kamna se sporákem nebo pecí',

  'estate_dashboard.estate_info.amenities.sauna_type.basic': 'Základní',
  'estate_dashboard.estate_info.amenities.sauna_type.luxurious': 'Luxusní',

  'estate_dashboard.estate_info.amenities.area': '{value}&nbsp;m²',

  // price graph
  'estate_dashboard.price_graph.price_millions': '{price} mil.',
  'estate_dashboard.price_graph.price_millions_with_currency':
    '{price} mil. Kč',
  'estate_dashboard.price_graph.title': 'Vývoj ceny v čase',

  'estate_dashboard.differences': '{percents}%',
  'estate_dashboard.differences.approx_diff_price': '{price}',

  'estate_dashboard.price_graph.title.last_3_months': 'Poslední 3 měsíce',
  'estate_dashboard.price_graph.title.last_year': 'Poslední rok',

  // get offer modal

  // Default
  'estate_dashboard.modal.get_offer.title':
    'Pro získání odhadu vyplňte kontaktní údaje',
  'estate_dashboard.modal.get_offer.subtitle':
    'Zjistěte nezávazně a zdarma odhad ceny nemovitosti a jak nejlépe prodat.',
  'estate_dashboard.modal.get_offer.full_name': 'Jméno a příjmení',
  'estate_dashboard.modal.get_offer.email': 'E-mail',
  'estate_dashboard.modal.get_offer.phone_number': 'Telefon',
  'estate_dashboard.modal.get_offer.button': 'Chci odhad ceny',
  'estate_dashboard.modal.get_offer.thank_you.title':
    'Vaši poptávku jsme v pořádku přijali.',
  'estate_dashboard.modal.get_offer.button.triggered_by_url_parameter':
    'Odeslat a zobrazit odhad',
  'estate_dashboard.modal.get_offer.thank_you.subtitle':
    'Vaši poptávku jsme v pořádku přijali. Brzy se vám ozveme s&nbsp;nabídkou a&nbsp;navrhneme vám další postup.',
  'estate_dashboard.modal.get_offer.thank_you.subtitle_triggered_by_url':
    'Brzy se vám ozveme a navrhneme vám další postup.',
  'estate_dashboard.modal.get_offer.thank_you.button_triggered_by_url':
    'Zobrazit odhad ceny',

  // subscribe modal
  'estate_dashboard.modal.subscribe.title': 'Sledujte cenu tohoto bytu',
  'estate_dashboard.modal.subscribe.subtitle':
    '1x měsíčně obdržíte e-mail s informacemi:',
  'estate_dashboard.modal.subscribe.benefit_1':
    'Co se v okolí prodalo a za kolik',
  'estate_dashboard.modal.subscribe.benefit_2': 'Aktuální odhad ceny bytu',
  'estate_dashboard.modal.subscribe.benefit_3': 'Realitní trendy v lokalitě',
  'estate_dashboard.modal.subscribe.unit_number': 'Jednotka č. {unitNumber}',
  'estate_dashboard.modal.subscribe.unknown_unit': 'Neznámá jednotka',
  'estate_dashboard.modal.subscribe.email': 'E-mail',
  'estate_dashboard.modal.subscribe.placeholder':
    'Zadejte vaši e-mailovou adresu',
  'estate_dashboard.modal.subscribe.button': 'Nastavit sledování',
  'estate_dashboard.modal.subscribe.thank_you':
    'Brzy se můžete těšit na aktuální informace o prodejích a cenách vybraného bytu.',

  // house subscribe modal
  'estate_dashboard.modal.house_subscribe.title':
    'Sledujte ZDARMA cenu tohoto domu',
  'estate_dashboard.modal.house_subscribe.subtitle':
    'Buďte pravidelně informováni o vývoji ceny této nemovitosti. Sledování můžete kdykoliv zrušit.',
  'estate_dashboard.modal.house_subscribe.benefit_1':
    'Co se v okolí prodalo a za kolik',
  'estate_dashboard.modal.house_subscribe.benefit_2':
    'Aktuální odhad ceny bytu',
  'estate_dashboard.modal.house_subscribe.benefit_3':
    'Realitní trendy v lokalitě',
  'estate_dashboard.modal.house_subscribe.unit_number':
    'Jednotka č. {unitNumber}',
  'estate_dashboard.modal.house_subscribe.unknown_unit': 'Neznámá jednotka',
  'estate_dashboard.modal.house_subscribe.email.label': 'E-mail',
  'estate_dashboard.modal.house_subscribe.email.placeholder':
    'Zadejte vaši e-mailovou adresu',
  'estate_dashboard.modal.house_subscribe.button': 'Nastavit sledování',
  'estate_dashboard.modal.house_subscribe.thank_you.title':
    'Sledování ceny je nastaveno',
  'estate_dashboard.modal.house_subscribe.thank_you.subtitle':
    'Blahopřejeme, začal/a jste sledovat cenu domu na&nbsp;adrese <b>{address}.</b>',

  // modal - thank you
  'estate_dashboard.modal.thank_you.title': 'Hotovo',
  'estate_dashboard.modal.thank_you.close': 'Zavřít',

  'estate_dashboard.open_atlas_section.title':
    'Za kolik se prodaly byty v okolí?',
  'estate_dashboard.open_atlas_section.content':
    'Zjistěte, za kolik se prodávají nemovitosti kolem vás. Nastavte si bezplatné hlídání cen a nic vám už neunikne.',
  'estate_dashboard.open_atlas_section.cta': 'Otevřít cenovou mapu',

  // price description
  'estate_dashboard.price_description.content':
    '<strong>Očekávali jste jinou cenu?</strong> Situace na trhu s realitami se v posledních měsících výrazně změnila, a proto jsme zpřesnili náš model výpočtu, aby lépe odrážel aktualní vývoj.',

  // Similar estates
  'estate_dashboard.similar_estates.title': 'Podobné prodeje v okolí',
  'estate_dashboard.similar_estates.seen': 'Už jste viděli',
  'estate_dashboard.similar_estates.load_more': 'Načíst další',

  'estate_dashboard.similar_estates.card.tag.activated': 'NOVĚ V INZERCI',
  'estate_dashboard.similar_estates.card.tag.deactivated':
    'ODSTRANĚNO Z INZERCE',
  'estate_dashboard.similar_estates.card.tag.sold': 'PRODÁNO',
  'estate_dashboard.similar_estates.card.tag.price_increased': 'ZDRAŽENO',
  'estate_dashboard.similar_estates.card.tag.price_decreased': 'ZLEVNĚNO',

  'estate_dashboard.similar_estates.card.estate_type.flat': `{disposition, select, 
    undefined {Byt}
    other {Byt {disposition}}
   }`,
  'estate_dashboard.similar_estates.card.estate_type.family_house': 'Dům',
  'estate_dashboard.similar_estates.card.estate_type.recreational_building':
    'Budova pro rekreaci',
  'estate_dashboard.similar_estates.card.area': '{area} m²',
  'estate_dashboard.similar_estates.card.price': '{price} Kč',
  'estate_dashboard.similar_estates.card.price_per_square_m': '{price} Kč/m²',

  'estate_dashboard.similar_estates.card.dispositions.1+kk': '1+kk',
  'estate_dashboard.similar_estates.card.dispositions.1+1': '1+1',
  'estate_dashboard.similar_estates.card.dispositions.2+kk': '2+kk',
  'estate_dashboard.similar_estates.card.dispositions.2+1': '2+1',
  'estate_dashboard.similar_estates.card.dispositions.3+kk': '3+kk',
  'estate_dashboard.similar_estates.card.dispositions.3+1': '3+1',
  'estate_dashboard.similar_estates.card.dispositions.4+kk': '4+kk',
  'estate_dashboard.similar_estates.card.dispositions.4+1': '4+1',
  'estate_dashboard.similar_estates.card.dispositions.5+kk': '5+kk',
  'estate_dashboard.similar_estates.card.dispositions.5+1': '5+1',
  'estate_dashboard.similar_estates.card.dispositions.larger': 'Větší',
  'estate_dashboard.similar_estates.card.dispositions.atypic': 'Atypický',

  'estate_dashboard.similar_estates.card.history_toggle.open':
    'Historie prodeje',
  'estate_dashboard.similar_estates.card.history_toggle.close':
    'Skrýt historii',

  'estate_dashboard.similar_estates.card.history.title': 'Historie nemovitosti',
  'estate_dashboard.similar_estates.card.history.event.activated':
    'Zahájení inzerce',
  'estate_dashboard.similar_estates.card.history.event.deactivated':
    'Ukončení inzerce',
  'estate_dashboard.similar_estates.card.history.event.sold': 'Prodáno',
  'estate_dashboard.similar_estates.card.history.event.price_increased':
    'Zdraženo',
  'estate_dashboard.similar_estates.card.history.event.price_decreased':
    'Zlevněno',
  'estate_dashboard.similar_estates.card.history.activate_change_detail':
    'za {price} Kč/m²',
  'estate_dashboard.similar_estates.card.history.price_change_detail':
    'o {percent}% na {price} Kč/m²',

  'estate_dashboard.similar_estates.toggle.close': 'Skrýt',
  'estate_dashboard.similar_estates.toggle.open': 'Rozbalit',

  // Ready to sell

  'estate_dashboard.ready_to_sell.title': 'Vaše lokalita je v kurzu!',
  'estate_dashboard.ready_to_sell.subtitle': `O podobné {estateType, select,
      flat {byty}
      house {domy}
      other {nemovitosti}
    } {locative} se právě zajímá {buyerCount} lidí. Ráda s Vámi proberu, jak prodat ten Váš.`,
  'estate_dashboard.ready_to_sell.cta': 'Zjistit zájem',

  'estate_dashboard.ready_to_sell.name': 'Anna',
  'estate_dashboard.ready_to_sell.description': 'Realitní specialistka Reas.cz',
});
